const getCfiscalFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'ncm', label: 'NCM', type: 'number', initial: true },
  { name: 'descricao', label: 'Descrição' },
  { name: 'produto_codigo', label: 'Código do Produto' },
  { name: 'produto_descricao', label: 'Descrição do Produto' },
  {
    name: 'utributaria_id',
    label: 'Unidade de Medida',
    type: 'select',
    options: drops?.UnidadeMedida,
    multiple: true,
  },
];

export default getCfiscalFilterFields;
